import { isMobile } from 'react-device-detect';
import styles from './leadership.module.scss';
import { LeadershipItem } from './leadershipItem/leadershipItem';
export interface LeaderShipModel {
  name: string;
  role: string;
  img: string;
  link: string;
}
const leaders: LeaderShipModel[] = [
  {
    name: 'Won',
    role: 'Co-CEO',
    img: 'img/leadership/Won.png',
    link: 'https://www.linkedin.com/in/won-soh',
  },
  {
    name: 'Deniz',
    role: 'Co-CEO',
    img: 'img/leadership/Deniz.png',
    link: 'https://www.linkedin.com/in/denizozzgur/',
  },
  {
    name: 'Karim',
    role: 'CTO',
    img: 'img/leadership/Karim.png',
    link: 'https://www.linkedin.com/in/karimvarela',
  },
  {
    name: 'Drew',
    role: 'Head of Product',
    img: 'img/leadership/Drew.png',
    link: 'https://www.linkedin.com/in/andrew-l0017/',
  },
  {
    name: 'Alejo',
    role: 'Head of Marketing',
    img: 'img/leadership/Alejo.png',
    link: 'https://www.linkedin.com/in/alejoescriva/',
  },
  {
    name: 'Josh',
    role: 'Head of Operations',
    img: 'img/leadership/Josh.png',
    link: 'https://www.linkedin.com/in/joshua-ramjit-03653a56/',
  },
  {
    name: 'Michael',
    role: 'Head of Partnerships',
    img: 'img/leadership/Michael.png',
    link: 'https://www.linkedin.com/in/michaelscarpellini',
  },
];
export const LeaderShip = () => {
  return (
    <>
      <div className={`${styles.leaderShip} container`} id="team">
        <div className={styles.title}>LEADERSHIP TEAM</div>
        <div className={styles.items}>
          {leaders.map((item) => (
            <LeadershipItem key={item.name} item={item} />
          ))}
        </div>
      </div>
    </>
  );
};
